import { Suspense } from "react";
import { Spinner } from "react-bootstrap";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";
import { Button, Input, SubTitle } from "../../Components/CustomComponents/index.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import Table from "../../Components/Table/Table.js";
import { useFoundingMember } from "./Hooks/useFoundingMember.js";
import styles from "./styles/user_management.module.scss";

const FoundingMemberManagementScreen = () => {
  const {
    rowData,
    columns,
    indication,
    totalRecords,
    totalPages,
    pageSize,
    currentPage,
    setCurrentPage,
    setPageSize,
    refetch,
    dataFetched,
    isFetching,
    isLoading,
    Modals,
    handleAddUser,
    searchQuery,
    handleSearchChange,
    handleConfirmModalOpen,
    deleteModal,
    handleDeleteModalClose,
    editedData,
    isDeleting,
    deleteData,
  } = useFoundingMember();

  return (
    <div className={styles.MainContainer}>
      <Modals />
      {deleteModal && (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      )}
      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Founding Members Management"} />
        </div>
        <div className="d-flex gap-4 ">
          <Input
            classes="w-50"
            type="search"
            placeholder="Search by name"
            value={searchQuery}
            onChange={handleSearchChange}
          />

          <Button
            classes={`${styles.cardBtn} `}
            style={{ height: "fit-content", width: "fit-content" }}
            text="Add Member"
            onClick={handleAddUser}
          ></Button>
        </div>
      </div>
      <div
        className={`${styles.mainTable} ${dataFetched && isFetching ? "blur-table" : ""
          }`}
      >
        {!dataFetched || isLoading ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            <Table
              classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
              data={rowData || []}
              columns={columns}
              indication={indication}
              totalRecords={totalRecords}
              totalPages={totalPages}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setPageSize={setPageSize}
              refetch={refetch}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FoundingMemberManagementScreen;
